import React, { useCallback, useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import CriticalBox from "./CriticalBox";
import axios from "axios";
import Select from "react-select";
import { criticalplacenewType } from "../../../reducer/postpayloadtypes";
import * as styles from "../../../styles/DefaultSetting";
import { SelectOptionType } from "../../../FrontType/index";
// import { Container } from "styles/MainPage";

const Critical = () => {
	const navigate = useNavigate();

	const targetFarmInfo = JSON.parse(localStorage.getItem("targetfarmInfo") || "{}");

	const [places, setPlaces] = useState<SelectOptionType[]>([]);
	const [placeParts, setPlaceParts] = useState<SelectOptionType[]>([]);

	const deaultPlace = { value: '', label: '선택' };
	const [selectedOption, setSelectedOption] = useState<any>({
		selectedPlace: deaultPlace,
		selectedPlacePart: deaultPlace,
	});

	const [enviromentTag, setEnviromentTag] = useState<any[]>([]);
	const [selectedTag, setSelectedTag] = useState<any>({
		tagId: "",
		tagName: "",
	});

	const [reload, setReload] = useState<boolean>(false);

	//! 💛 API 정의
	const getSpecificplace = (placeInfo: any): Promise<any[]> => {
		if (!placeInfo) return Promise.reject('No place info provided');

		const data = { placeId: placeInfo.value };

		return axios.get(`ifactory/api/place/specificplace?`, { params: data })
			.then((response) => {
				return response.data.map((place: any) => {
					return {
						value: place.placeId,
						label: place.name,
					};
				});
			})
			.catch((error) => {
				console.error(error);
				throw error;
			});
	}

	const getTag = (placeId: number): Promise<any[]> => {
		if (!selectedOption.selectedPlace) return Promise.reject('No selected place info provided');

		return axios.get(`ifactory/api/tag/${placeId}`)
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.error(error);
				throw error;
			});
	};

	//! 💛 마운트 EFFECT 정의
	// 마운트 시, 현재 농장 정보를 기준으로 사육실 정보를 가져온다.
	useEffect(() => {
		if (!targetFarmInfo) return;

		// 현재 농장 정보(targetFarmInfo에서 placeId)를 기준으로 사육실/사육구역 정보를 가져온다.
		const requestParam = { label: targetFarmInfo.name, value: targetFarmInfo.placeId };

		getSpecificplace(requestParam)
			.then((data) => {
				setPlaces(data);
				setSelectedOption({ ...selectedOption, selectedPlace: data[0] });
			})
			.catch((error) => {
				console.error(error);
			})
	}, []);

	// selectedOption의 selectedPlace가 변경되면, 해당 사육실의 사육구역의 정보를 가져온다.
	useEffect(() => {
		if (!selectedOption.selectedPlace.value) return;

		getSpecificplace(selectedOption.selectedPlace)
			.then((data) => {
				setPlaceParts([{ value: '', label: '선택' }, ...data]);
				setSelectedOption({ ...selectedOption, selectedPlacePart: deaultPlace }); // 사육구역의 기본값은 '선택'으로 설정
			})
			.catch((error) => {
				console.error(error);
			});

		// getSpecificplace
	}, [selectedOption.selectedPlace]);

	// selectedOption의 selectedPlacePart(사육구역)의 value가 ''이면 selectedPlace(사육실)의 value를 사용한다.
	useEffect(() => {
		if (!selectedOption.selectedPlace.value) return;

		const placeId = selectedOption.selectedPlacePart.value || selectedOption.selectedPlace.value;

		if (!placeId) return;

		getTag(placeId)
			.then((data) => {
				if (data.length === 0) {
					setEnviromentTag([]);
					setSelectedTag({ tagId: "", tagName: "" });
					return;
				}
				setEnviromentTag(data);
				setSelectedTag({ tagId: data[0].tagId, tagName: data[0].name });
			})
			.catch((error) => {
				console.error(error);
			});
	}, [selectedOption.selectedPlacePart, reload]);

	//! 💛 이벤트 핸들러 정의
	const tagChange = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		const target = e.target as HTMLButtonElement;
		const tagId = target.parentElement?.id;
		const tagName = target.textContent;

		if (!tagId || !tagName) return;

		const tag = { tagId, tagName };

		setSelectedTag(tag);
	}, []);


	return (
		<styles.Container style={{
			display: "flex",
			flexDirection: "column",
			height: "100vh",
		}}>
			<styles.PageTop>
				<p className="move-btn">
					<img src="./img/ArrowLeft.svg" onClick={() => { navigate("/MainPage"); }} alt="좌향버튼" />
				</p>
				<p className="pagetit">기본설정</p>
			</styles.PageTop>
			<styles.PageTitle>
				<div className="title">
					<p>임계치 관리</p>
					<Select
						options={places}
						value={selectedOption.selectedPlace}
						onChange={(e) => {
							setSelectedOption({ ...selectedOption, selectedPlace: e });
						}}
						styles={{
							control: (baseStyles: any, state: any) => {
								return {
									...baseStyles,
									marginLeft: "10px",
								}
							},
							menu: (baseStyles: any, state: any) => {
								return {
									...baseStyles,
									width: "auto",
								}
							}
						}} />

					<Select
						options={placeParts}
						value={selectedOption.selectedPlacePart}
						onChange={(e) => {
							setSelectedOption({ ...selectedOption, selectedPlacePart: e });
						}}
						styles={{
							control: (baseStyles: any, state: any) => {
								return {
									...baseStyles,
									marginLeft: "10px",
								}
							},
							menu: (baseStyles: any, state: any) => {
								return {
									...baseStyles,
									width: "auto",
								}
							}
						}} />
				</div>
			</styles.PageTitle>

			<styles.ContentBox>
				{/* 선택된 사육실or사육구역의 환경 TAG 선택 리스트 */}
				<TagBox>
					<ul>
						{enviromentTag.map((tag, idx) => {
							return (
								<li key={idx} id={tag.tagId}>
									<button type="button"
										onClick={tagChange}
										className={Number(selectedTag.tagId) === Number(tag.tagId) ? 'active' : ''}>
										{tag.name}
									</button>
								</li>
							)
						})}
					</ul>
				</TagBox>

			</styles.ContentBox>

			<styles.ContentBox style={{
				backgroundColor: "rgb(255, 255, 255)",
				flexGrow: 1,
				display: "flex",
				justifyContent: "flex-start",
				flexWrap: "wrap",
				alignItems: "flex-start",
				padding: "40px"
			}}>
				{/* 선택된 TAG 환경 정보 */}
				<CriticalBox
					selectedTag={selectedTag}
					selectedOption={selectedOption}
					enviromentTag={enviromentTag}
					setReload={setReload}
				/>
			</styles.ContentBox>
		</styles.Container>
	);
};

export default Critical;

const TagBox = styled.div`
	display: flex;
	padding: 20px 40px;
	background-color: #f5f5f5;
	& ul {
		width: 100%;
		display: flex;
		justify-content: space-between;
		& li {
			height: 34px;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-right: 8px;
			& button {
				height: 100%;
				background-color: #666;
				color: #fff;
				font-size: 0.9em;
				padding: 0.5em 1em;
				border-radius: 8px;
				cursor: pointer;
				word-break: keep-all;

				// reset
				border: none;
				outline: none;

				// hover
				&:hover {
					filter: brightness(1.2);
				}

				// active
				&.active {
					background-color: #73972c;
				}
			}
		
		}
	}
`;